module.exports = __webpack_public_path__ + "static/media/iced_boots.5b370264.png";